var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFocus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.15,
    x2: 1.222,
    y2: 1.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6a81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d752ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-focus",
    transform: "translate(-1681 -859)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ico-fidelity",
    width: 24,
    height: 24,
    transform: "translate(1681 859)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ico-focus-2",
    "data-name": "ico-focus",
    d: "M9.858,19.71,12,16H5.07A8.018,8.018,0,0,0,9.858,19.71ZM4.252,14H8.536L5.071,8a8.026,8.026,0,0,0-.819,6ZM6.395,6.292,8.536,10,12,4A7.974,7.974,0,0,0,6.395,6.292Zm7.747-2L12,8h6.93A8.018,8.018,0,0,0,14.142,4.29ZM19.748,10H15.464l3.465,6a8.027,8.027,0,0,0,.819-6ZM17.6,17.708,15.464,14,12,20A7.974,7.974,0,0,0,17.6,17.708ZM12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Zm1.155-12H10.845L9.691,12l1.155,2h2.309l1.155-2Z",
    transform: "translate(1681 859)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFocus);
export default __webpack_public_path__ + "static/media/ico-focus.b544d3e3fe6f936b451eaf55f81db48a.svg";
export { ForwardRef as ReactComponent };